module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row">\n	<div class="col-md-12">\n		<h2>Search results</h2>\n		<div id="search-results-region"></div>\n	</div>\n</div>';
}
return __p;
};
